module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAABHNCSVQICAgIfAhkiAAAAJdJREFUGJV9z7ENwjAQBdD/4+tJaSkT0P0RwgaswGZsEkqqYEagcxn6OKYhkhXF+d2d7kn/iJ1Ias1sAIB5ni8hhGl7wwOk/yrs4aaGcs7vnPMXgMxskNTuwi1KKfUppb6GWUNrNUlyzj1InsraPEJFG5nZq/zZdV33JFlFABBjjN77D8krAE/y3JCcjtCacRzvy7Lc1vkHOpZ2zs27rkwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chev-up.png
// module id = 2580
// module chunks = 0